export const GET_DAILY_EVENTS_WORKING_LOGS_REQUEST =
  "GET_DAILY_EVENTS_WORKING_LOGS_REQUEST";

export const GET_DAILY_EVENTS_WORKING_LOGS_RESPONSE =
  "GET_DAILY_EVENTS_WORKING_LOGS_RESPONSE";

export const EXPORT_EXCEL_REQUEST = "EXPORT_EXCEL_REQUEST";
export const EXPORT_EXCEL_RESPONSE = "EXPORT_EXCEL_RESPONSE";
